<template>
  <v-layout>
    <v-flex>
      <v-card class="pa-6 pt-4 mt-10">
        <v-card-title>
          Dispatch Orders
          <v-spacer></v-spacer>
          <v-select
            v-model="status"
            :items="statuses"
            @change="filterBy"
            menu-props="auto"
            label="Status"
            item-text="name"
            class="max-width-300 mr-10"
            prepend-icon="mdi-filter-outline"
            item-value="id"
            hide-details
          >
          </v-select>
          <v-text-field
            v-model="search"
            class="table-search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details>
          </v-text-field>
        </v-card-title>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="deliveries"
          :server-items-length="pagination.total"
          :items-per-page="pagination.per_page"
          :footer-props="{ itemsPerPageOptions: [10, 20, 30] }"
          :loading="loading"
          loading-text="Loading Dispatch Orders..."
          item-key="id"
          no-data-text="No Dispatch Orders Found"
          :options.sync="options"
          ref="table">

          <template v-slot:[`item.delivery_no`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-truck-fast-outline
              </v-icon>
              {{ item.delivery_no }}
            </div>
          </template>

          <template v-slot:[`item.deliver_to_name`]="{ item }">
            <div class="d-flex align-center">
              <v-icon
                size="24"
                class="mr-1">
                mdi-account-outline
              </v-icon>
              {{ item.deliver_to_name }}
            </div>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <DeliveryStatus :status="item.status" :small="true" :statuses="statuses"></DeliveryStatus>
          </template>

          <template v-slot:[`item.delivery_date`]="{ item }">
            {{ item.delivery_date | moment("MMM D, YYYY") }}
          </template>

          <template v-slot:[`item.created_at`]="{ item }">
            {{ item.created_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:[`item.updated_at`]="{ item }">
            {{ item.updated_at | moment("MMM D, YYYY h:mm A") }}
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="mr-2"
                  color="primary"
                  @click="viewItem(item.id)">
                  mdi-magnify
                </v-icon>
              </template>
              <span>View</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    </v-flex>
  </v-layout>

</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import DeliveryStatus from '@/components/DeliveryStatus.vue'

  export default {
    name: 'DOsPage',
    data() {
      return {
        adminNamespace: 'admin',
        snackbarDetails: {
          color: 'sb-success',
          msg: '',
          show: false
        },
        error:{
          show: false,
          status: '',
          error: '',
          messages: {}
        },
        firstLoad: true,
        loading: false,
        search: '',
        awaitingSearch: false,
        selected: [],
        status: '',
        statuses: [],
        deliveries: [],
        pagination: {
          page: 1,
          per_page: 1,
          total: 0,
          next: 0
        },
        options: {},
        headers: [
          {
            text: 'DO No.',
            align: 'start',
            value: 'delivery_no',
            sortable: false
          },
          {
            text: 'Shipping Mark',
            align: 'start',
            value: 'shipping_marks',
            sortable: false
          },
          {
            text: 'Container',
            align: 'start',
            value: 'containers',
            sortable: false
          },
          {
            text: 'DO Date',
            align: 'start',
            value: 'delivery_date',
            sortable: false
          },
          {
            text: 'Client Name',
            align: 'start',
            value: 'deliver_to_name',
            sortable: false
          },
          {
            text: 'Client Contact No',
            align: 'start',
            value: 'deliver_to_contact_no',
            sortable: false
          },
          {
            text: 'Created Date',
            align: 'start',
            value: 'created_at',
            width: 180,
            sortable: false
          },
          {
            text: 'Status',
            align: 'start',
            value: 'status',
            sortable: false,
            width: 90
          },
          {
            text: '',
            value: 'action',
            sortable: false,
            width: 50
          }
        ]
      }
    },
    computed: {
      ...mapGetters(['getUserInitial', 'formatNumber', 'formatNumberAmount']),
      hasSelected: function(){
        return this.selected.length != 0 ? false : true
      }
    },
    watch: {
      options: {
        handler () {
          this.getDeliveryOrders()
        },
        deep: true,
      },
      search: function (val) {
        if (!this.awaitingSearch) {
          setTimeout(() => {
            this.options.page = 1
            this.getDeliveryOrders()
            this.awaitingSearch = false;
          }, 1000); // 1 sec delay
        }
        this.awaitingSearch = true;
      },
    },
    methods: {
      filterBy (id) {
        this.status = id
        this.options.page = 1
        this.getDeliveryOrders()
      },
      itemRowBackground: function (item) {
         return item.sales_agent > 0 ? '' : 'bg-lightblue'
      },
      getAgentName: function(id){
        let agents = this.agents.filter(agent => {
          return agent.id == id
        })
        if(agents.length > 0){
          let agent = agents[0]
          return agent.first_name + ' ' + agent.last_name
        }
      },
      getStatusName: function(id){
        let statuses = this.statuses.filter(status => {
          return status.id == id
        })
        if(statuses.length > 0){
          return statuses[0].name
        }
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?delivery_statuses=true')
          .then(response => {
            let allowedStatuses = [
              '',
              this.$getConstDeliveryStatus('DELIVERY_STATUS_CREATED'),
              this.$getConstDeliveryStatus('DELIVERY_STATUS_DELIVERED'),
              this.$getConstDeliveryStatus('DELIVERY_STATUS_DELETED')
            ]

            response.data.delivery_statuses.forEach(obj => {
              if(allowedStatuses.includes(obj.id)) this.statuses.push(obj)
            })
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      viewItem (id) {
        this.$router.push({ name: 'delivery-view', params: { id: id } })
      },
      getDeliveryOrders () {
        if (this.loading) {
          return false
        }

        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        let sorting = []
        let params = []

        if (sortBy.length === 1 && sortDesc.length === 1) {
          sortBy.forEach(function (item, index) {
            let sort = 'ASC'
            if (!sortDesc[index]) {
              sort = 'DESC'
            }
            sorting.push(item+'='+sort)
          });
        }

        params = { page: page, per_page: itemsPerPage }
        if (this.search.length > 0) params.search = this.search
        if (this.status.length > 0) params.status = this.status

        if(!this.firstLoad){
          this.$router.push({ name: 'delivery-orders-page', params: { page: page }})
        }

        this.firstLoad = false

        this.loading = true
        let self = this
        this.$http.plain.get(this.adminNamespace+'/deliveries', { params: params })
          .then(response => {
            this.deliveries = response.data.deliveries

            if (response.data.pagination) {
              let pagination = response.data.pagination

              this.pagination.total = pagination.count
            }

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
        }
    },
    mounted() {
      if(this.$route.params.page){
        this.options.page = parseInt(this.$route.params.page)
      }

      this.getDefaultData()
    },
    components: {
      SnackBar,
      DeliveryStatus
    },
  }
</script>
